import React from "react";
import MatrixOSInfoShell from "./MatrixOSInfoShell";
import { LegalSection } from "./legalContentStyles";

export default function DataProcessing() {
  return (
    <MatrixOSInfoShell eyebrow="Data Processing" title="MatrixOS data processing principles." subtitle="A practical summary for customers using MatrixOS with workforce, stock, response, site, POS, dispatch, and operational records.">
      <LegalSection title="1. Roles">
        The customer generally decides what business and personal information is entered into MatrixOS and for what operational purpose. MatrixOS processes that information to provide, secure, support, bill, and improve the service.
      </LegalSection>
      <LegalSection title="2. Processing purposes">
        Processing may include authentication, access control, linked-device management, schedules, attendance, duty execution, exception and decision history, Response Intelligence, stock preparation, count sessions, verification, variance, exposure, multi-site reporting, notifications, support, billing, integrations, audits, backups, security monitoring, and service improvement.
      </LegalSection>
      <LegalSection title="3. Customer instructions">
        Customers must only submit information they are authorized to process and must give MatrixOS accurate instructions through configuration, permissions, schedules, standards, site setup, rollout scope, and support requests.
      </LegalSection>
      <LegalSection title="4. Notifications and sub-processors">
        MatrixOS may use cloud hosting, authentication, storage, email, messaging, payment, analytics, and integration providers where needed to operate the service. Where WhatsApp or email alerts are enabled, recipient and operational context may be processed by the relevant provider to deliver the message.
      </LegalSection>
      <LegalSection title="5. Audit and operational history">
        MatrixOS may retain decision, attendance, duty, count, verification, response, and other operational history where needed for service operation, reporting, auditability, support, billing, security, or legal obligations.
      </LegalSection>
      <LegalSection title="6. Requests">
        Data-processing questions can be sent through the MatrixOS Contact page or to admin@matrixos.co.za.
      </LegalSection>
    </MatrixOSInfoShell>
  );
}
